(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hdr = document.querySelector('.hdr');
  if (hdr){ var s=function(){ hdr.classList.toggle('stuck', scrollY>6); }; addEventListener('scroll',s,{passive:true}); s(); }
  var b=document.querySelector('.burger'), n=document.querySelector('.nav');
  if(b&&n) b.addEventListener('click',function(){ n.classList.toggle('open'); });

  var rv=document.querySelectorAll('.rv');
  if(rv.length){
    if('IntersectionObserver' in window && !reduce){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px',threshold:.1});
      rv.forEach(function(el){io.observe(el);});
    } else rv.forEach(function(el){el.classList.add('in');});
  }

  if(!reduce){
    var par=[].slice.call(document.querySelectorAll('[data-par]')), t=false;
    var f=function(){ t=false; par.forEach(function(el){
      var r=el.getBoundingClientRect(), vh=innerHeight;
      if(r.bottom<-200||r.top>vh+200) return;
      var p=(r.top+r.height/2-vh/2)/vh;
      var amt=parseFloat(el.getAttribute('data-par'))||14;
      el.style.transform='translate3d(0,'+(-p*amt)+'%,0) scale(1.12)';
    }); };
    var q=function(){ if(!t){t=true;requestAnimationFrame(f);} };
    addEventListener('scroll',q,{passive:true}); addEventListener('resize',q); f();
  }

  var form=document.querySelector('[data-buy]');
  if(form){
    var scope=form.closest('.buy')||document;
    var pe=scope.querySelector('[data-price]'),
        ce=scope.querySelector('[data-compare]'),
        se=scope.querySelector('[data-save]'),
        id=form.querySelector('[data-id]'),
        qe=form.querySelector('[data-qty]'),
        cn=scope.querySelector('[data-color-name]'),
        gm=scope.querySelector('[data-main]');

    var pkgOpts=form.querySelectorAll('.opts .opt');
    function pickPkg(o){
      pkgOpts.forEach(function(x){x.classList.remove('on');});
      o.classList.add('on');
      var r=o.querySelector('input'); if(r) r.checked=true;
      if(qe) qe.value = o.getAttribute('data-qty') || '1';
      if(pe) pe.textContent = o.getAttribute('data-price') || '';
      var cmp=o.getAttribute('data-compare')||'';
      if(ce){ ce.textContent=cmp; ce.style.display=cmp?'':'none'; }
      var sav=o.getAttribute('data-save')||'';
      if(se){ se.textContent=sav; se.style.display=sav?'':'none'; }
    }
    pkgOpts.forEach(function(o){
      o.addEventListener('click',function(){ pickPkg(o); });
      var r=o.querySelector('input'); if(r) r.addEventListener('change',function(){ pickPkg(o); });
    });
    var onInit = form.querySelector('.opts .opt.on') || pkgOpts[0];
    if(onInit) pickPkg(onInit);

    var swatches=scope.querySelectorAll('.sw');
    function pickSw(sw){
      swatches.forEach(function(x){x.classList.remove('on');});
      sw.classList.add('on');
      var vid=sw.getAttribute('data-vid');
      if(id && vid) id.value=vid;
      if(cn) cn.textContent = sw.getAttribute('data-color') || '';
      var img=sw.getAttribute('data-img');
      if(gm && img){ gm.src=img; }
    }
    swatches.forEach(function(sw){ sw.addEventListener('click',function(){ pickSw(sw); }); });
    var swOn = scope.querySelector('.sw.on') || swatches[0];
    if(swOn) pickSw(swOn);
  }

  var mbar=document.querySelector('[data-mbar]');
  if(mbar){
    document.body.classList.add('has-mbar');
    var buy=document.querySelector('#koupit');
    var hact=document.querySelector('.hero__act');
    function vis(el,f){ if(!el) return false; var r=el.getBoundingClientRect(); return r.top < innerHeight*(f||1) && r.bottom > 0; }
    function mb(){
      mbar.classList.toggle('show', !(vis(buy,0.9) || vis(hact,1)));
    }
    addEventListener('scroll',mb,{passive:true}); addEventListener('resize',mb); mb();
  }

  var g=document.querySelector('[data-gal]');
  if(g){
    var m=g.querySelector('[data-main]');
    g.querySelectorAll('[data-th]').forEach(function(t){
      t.addEventListener('click',function(){
        g.querySelectorAll('[data-th]').forEach(function(x){x.classList.remove('on');});
        t.classList.add('on'); if(m) m.src=t.dataset.full;
      });
    });
  }
})();